import React, {useEffect, useState} from "react"
import {
  Card,
  CardBody,
  Col,
  Table,
  CardTitle,
} from "reactstrap"
import {getUserTickets} from "../../../helpers/repository";
import axios from "axios";
import {API_URL} from "../../../constants/constants";
import {convertToDateTimeString} from "../../../helpers/helpers";
export default function PromotionRewards (props) {
  const [promotionData, setPromotionData] = useState([])
  const call = () => {
    axios({
      method: "get",
      url: `${API_URL}/admin/get-promotion-reward/${props.userId}`,
    })
        .then(function (response) {
          console.log(response?.data?.data)
          setPromotionData(response?.data?.data)
        })
        .catch(function (response) {
        })
  }
  useEffect(() => {
    call()
  }, [props.userId])

  return (
    <Col lg={6}>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">USED PROMOTIONS</CardTitle>
          {promotionData?.first_deposit &&
          promotionData?.first_deposit.length != 0 ? (
            <div className="table-responsive">
              <Table className="table mb-0">
                <thead>
                  <tr>
                    <th>Date Added</th>
                    <th>Type</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="table-danger">
                    <td scope="row">
                      {convertToDateTimeString(
                        promotionData?.first_deposit[0].date_added
                      )}
                    </td>
                    <td>{promotionData?.first_deposit[0].type}</td>
                    <td>{promotionData?.first_deposit[0].amount}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          ) : (
            ""
          )}
          {promotionData?.LoyaltyPromo &&
          promotionData?.LoyaltyPromo.length != 0 ? (
            <div className="table-responsive" style={{ marginTop: "20px" }}>
              <Table className="table mb-0">
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>Type</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {promotionData?.LoyaltyPromo?.map((loyaltyPromo, key) => (
                    <tr key={key} className="table-success">
                      <th scope="row">
                        {convertToDateTimeString(loyaltyPromo?.date_added)}
                      </th>
                      <td>{loyaltyPromo?.type}</td>
                      <td>{loyaltyPromo?.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            ""
          )}
          {promotionData?.Acca7 && promotionData?.Acca7.length != 0 ? (
            <div className="table-responsive" style={{ marginTop: "20px" }}>
              <Table className="table mb-0">
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>Type</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {promotionData?.Acca7?.map((acca, key) => (
                    <tr key={key} className="table-success">
                      <th scope="row">
                        {convertToDateTimeString(acca?.date_added)}
                      </th>
                      <td>{acca?.type}</td>
                      <td>{acca?.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            ""
          )}
          {promotionData?.SignupFreebet &&
          promotionData?.SignupFreebet.length != 0 ? (
            <div className="table-responsive" style={{ marginTop: "20px" }}>
              <Table className="table mb-0">
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>Type</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {promotionData?.SignupFreebet?.map((Signup, key) => (
                    <tr key={key} className="table-primary">
                      <th scope="row">
                        {convertToDateTimeString(Signup?.date_added)}
                      </th>
                      <td>{Signup?.type}</td>
                      <td>{Signup?.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            ""
          )}
        </CardBody>
      </Card>
    </Col>
  )
}
